import '../../styles/App.scss'
import '../../styles/Chat.scss'

import * as React from 'react' 
import { Avatar } from '@material-ui/core'
import images from '../../images';
import { FlatButton } from 'material-ui';
import * as classnames from 'classnames'
import { StringResources } from '../../localization/StringResources'
import { Strings } from '../../localization'
import { ChatMessage } from '../../types/ChatMessage';
import {Hash} from '../../utils/securityUtils'

interface Props {
    message: ChatMessage
    isGroupChat: boolean
    messageText: string
    isInReplyMode:boolean
    isQuestionAsnwered?: boolean
    onReplyClick:(replySid?: string) => void
}

interface State{
    isInReplyMode:boolean
}

export class ChatProviderMessageItem extends React.Component<Props, State>
{
    constructor(props) {
        super(props)
        this.state ={
            isInReplyMode:false
        }
    }

    onReplyBtnClick = () => {
        
        this.setState({isInReplyMode: !this.props.isInReplyMode})
        this.props.onReplyClick(this.props.message.sid)
    }


    render()
    {
        return(
            <div className="message received">
                <div className='message-header'>
                <Avatar
                src={this.props.message.attributes.authorAvatar ? this.props.message.attributes.authorAvatar : images.avatar2}
                className="chat-avatar"
                />
                <h3 className='message-author'>{ this.props.isGroupChat ? `Provider - ${Hash.dummyHashCode(this.props.message.author)}` : 'Provider'}</h3>
                </div>
                <div className="talk-bubble tri-right left-top">
                    <div className="talktext">
                        <p>{this.props.message.body}</p>
                    </div>
                </div>
                {/*{*/}
                    {/*this.props.isGroupChat && !this.props.isQuestionAsnwered ? */}
                        {/*<FlatButton*/}
                            {/*label={this.state.isInReplyMode ? StringResources.getString(Strings.Components.ChatProviderMessageItem.Buttons.Cancel.label) : */}
                                                              {/*StringResources.getString(Strings.Components.ChatProviderMessageItem.Buttons.Reply.label)}*/}
                            {/*className={classnames('flatbutton', 'btn-reply', {'btn-cancel-reply': this.state.isInReplyMode}, */}
                                                                             {/*{disabled: (this.props.isInReplyMode && !this.state.isInReplyMode)})}*/}
                            {/*onClick={this.onReplyBtnClick}*/}
                            {/*disabled={this.props.isInReplyMode && !this.state.isInReplyMode} //globally in reply mode, but not in this component*/}
                        {/*/> */}
                        {/*: */}
                        {/*null*/}
                {/*}*/}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Chat/ChatProviderMessageItem.tsx